export function transform(number: number, digit = 2) {
    return ('0' + number).slice(-digit);
}
